import React from 'react';
import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const ViewWrap = styled.div`
  display: none;

  @media ${minBp('tabletLarge')} {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 1;
  }
`;

export const LabelWrap = styled.div`
  margin-right: 10px;
  color: #000;
`;

export const IconWrap = styled.div`
  ${({ active }) => `
    cursor: pointer;

    &:not(:last-of-type) {
      margin-right: 4px;
    }

    svg {
      path {
        fill: ${active ? '#000' : '#c1c1c1'};
      }
    }
  `}
`;

export const SelectWrap = styled.div`
  border: 1px solid #000;
  position: relative;
  margin-left: 4px;
  flex: 1;
  min-width: 50%;

  svg {
    position: absolute;
    top: 10px;
    right: 8px;
    width: 16px;
    height: 16px;
    pointer-events: none;
  }

  @media ${minBp('tabletLarge')} {
    min-width: 140px;
    flex: none;
    margin-left: 20px;

    svg {
      top: 12px;
    }
  }
`;

export const Select = styled.select`
  appearance: none;
  border: 0;
  border-radius: 0;
  padding: 10px 35px 8px 15px;
  margin: 0;
  color: #000;
  background: transparent;
  width: 100%;
  text-align: left;
  font-family: inherit;
  font-size: 16px;

  &:focus {
    border: 0;
    outline: 2px auto #9ecaed;
    outline: 2px auto -webkit-focus-ring-color;
    outline-offset: 5px;
    transition: none;
  }
`;
